import firebase from "@firebase/app";
import "@firebase/auth";
import axios from "axios";

const initialState = () =>({
    authToken:null,
    autherror:null,
    user: null,
    permissions: {}
 });
 

const state = initialState();

const getters = {
    authToken: (state) => state.authToken,
    isAuthenticated: state => !!state.user,
    isTokenExpired: state => {
        if (!state.authToken) return true;
        const payload = JSON.parse(atob(state.authToken.split('.')[1]));
        return payload.exp < Date.now() / 1000;
    },
    // Getter to retrieve permissions based on authIdentifier
    getPermissions: (state) => (authIdentifier) => {
        return state.permissions[authIdentifier];
    },
    hasPermissions: state => {
        return Object.keys(state.permissions).length > 0;
    }
}

const mutations = {
    setauthToken(state, payload) {
        state.authToken = payload;
    },  
    seterror(state,payload){
        state.autherror = payload
    },
    removeauthToken(state){
        state.authToken = null;
    },
    setUser(state, user) {
        state.user = user;
    },
    setPermissions(state, permissions) {  // Mutation to set permissions
        state.permissions = permissions;
    },
    RESET_STATE(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
          state[key] = newState[key];
        });
    },

};

const actions = {
    initializeAuth({ commit }) {
        firebase.auth().onAuthStateChanged(user => {
          if (user) {
            user.getIdToken().then(token => {
              commit('setAuthToken', token);
              commit('setUser', user);
            });
          } else {
            commit('setAuthToken', null);
            commit('setUser', null);
          }
        });
    },
    getToken({commit}){
        const idToken = firebase
        .auth()
        .currentUser
        .getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {           
        commit("setauthToken",idToken)
        // alert(idToken.user.uid)
        // console.log(idToken)
        }).catch(function(error) {
        // Handle error
        console.log(error)
        commit("seterror",idToken)
        });
    },
    auth_error({commit},payload){
        commit("seterror",payload)
    },
    removeauthToken({commit}){
        commit("removeauthToken")
    },
    // refreshToken({commit}){
    //     const idToken = firebase
    //     .auth()
    //     .currentUser
    //     .getIdToken(/* forceRefresh */ true)
    //     .then(function(idToken) {
    //       axios.defaults.headers.common['Authorization'] = "token "+idToken
    //       commit("setauthToken",idToken)
    //       }).catch(function(error) {
    //       // Handle error
    //       console.log('onrefresh token error',error)
    //       commit("seterror",idToken)
    //       // if getIdToken fails, then sign the user out
    //       //   dispatch('signUserOut');
    //       });     

    // },
    
    async refreshToken({ commit, dispatch }) {
        try {
            const idToken = await firebase.auth().currentUser.getIdToken(true);
            axios.defaults.headers.common['Authorization'] = "token " + idToken;
            commit("setauthToken", idToken);
        } catch (error) {
            // console.log('on refresh token error', error);
            commit("seterror", error);
    
            // If getIdToken fails, then sign the user out
            dispatch('signUserOut');
            throw error; // Rethrow the error so the calling code can handle it
        }
    },
    async fetchAndStorePermissions({ commit, rootGetters }) {
        const currentUser = firebase.auth().currentUser;
        if (!currentUser) {
            console.warn("No user logged in");
            return;
        }
    
        const userId = currentUser.uid;
        const userRoles = rootGetters['users/getUserRoles']; // Assuming you now want to include this
        console.log("userRoles",userRoles)
        // const userRoles = store.state.user.fbuserdata?.roles ?? [];
        const permissionsRef = firebase.firestore().collection('route_permissions');
        
        let promises = [];
    
        // Query to fetch permissions by specific user ID
        const userPromise = permissionsRef.where('specificUsers', 'array-contains', userId).get();
        promises.push(userPromise);
        console.log("userPromise",userPromise)
        // Query to fetch permissions by roles, if roles are available
        if (userRoles && userRoles.length) {
            const rolesPromise = permissionsRef.where('roles', 'array-contains-any', userRoles).get();
            promises.push(rolesPromise);
        }
    
        Promise.all(promises).then(results => {
            let permissions = {};
            results.forEach(querySnapshot => {
                querySnapshot.forEach(doc => {
                    permissions[doc.id] = doc.data(); // Merge permissions, no overwriting issues
                });
            });
            commit('setPermissions', permissions);
        }).catch(error => {
            console.error("Failed to fetch permissions:", error);
            commit('setPermissions', {}); // Set permissions to a safe default on error
        });
    },
    // async fetchAndStorePermissions({ commit }) { //rootGetters
    //     const currentUser = firebase.auth().currentUser;
    //     if (!currentUser) {
    //       console.log("No user logged in");
    //       return;
    //     }
      
    //     // const userRoles = rootGetters['someModule/getUserRoles']; // Example getter for user roles
    //     const userId = currentUser.uid;
    //     const permissionsRef = firebase.firestore().collection('route_permissions');
      
    //     let permissions = {}; // Declare permissions object outside to ensure scope availability
      
    //     // First query to fetch permissions by specific user ID
    //     permissionsRef.where('specificUsers', 'array-contains', userId)
    //       .get()
    //       .then(querySnapshot => {
    //         querySnapshot.forEach(doc => {
    //           permissions[doc.id] = doc.data();
    //         });
    //         commit('setPermissions', permissions);
    //       })
    //       .catch(error => {
    //         console.error("Failed to fetch permissions by user ID:", error);
    //         commit('setPermissions', {}); // Set permissions to a safe default on error
    //       });
      
    //     // // Second query to fetch permissions by roles (if userRoles is available)
    //     // if (userRoles && userRoles.length) {
    //     //   permissionsRef.where('roles', 'array-contains-any', userRoles)
    //     //     .get()
    //     //     .then(querySnapshot => {
    //     //       querySnapshot.forEach(doc => {
    //     //         if (!permissions[doc.id]) { // Avoid overwriting if already set
    //     //           permissions[doc.id] = doc.data();
    //     //         }
    //     //       });
    //     //       commit('setPermissions', permissions);
    //     //     })
    //     //     .catch(error => {
    //     //       console.error("Error fetching permissions by roles:", error);
    //     //     });
    //     // }
    // },
      
    authchange({ dispatch }){
    // listen for auth status changes
        firebase.auth().onAuthStateChanged(user => {
            if(user){
                console.log('user logged in: ', user);
                dispatch('fetchAndStorePermissions');
            }else {
                console.log('user logged out');
            }    
        })
    },
};

export default {
    namespace: true,
    state,
    getters,
    actions,
    mutations,
  };
  

